import { render, staticRenderFns } from "./PedidoEstatus.vue?vue&type=template&id=f22605fc&"
import script from "./PedidoEstatus.vue?vue&type=script&lang=js&"
export * from "./PedidoEstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports